// interfaces / constants
import { EventFormat } from '@lopo-tech/lopo-api'

/**
 * The two conditional requirements of the event schema, for everything that
 * writes or shows an event.
 *
 * They decide three different things - which fields the wizard asks for, what
 * goes into the mutation, and which rows the card renders - and those must not
 * drift apart. A form that shows a field it never sends, or withholds one the
 * server insists on, tells the user about it through the generic error, which is
 * the worst channel for it.
 *
 * `undefined` reads as in person: that is the format an event carries when
 * nothing chose one, and the preselected option of the wizard.
 */
export const formatNeedsPlace = (format?: EventFormat) =>
  format !== EventFormat.Online

export const formatNeedsLink = (format?: EventFormat) =>
  format === EventFormat.Online || format === EventFormat.Hybrid
